import { Pharmacy } from 'app/types';

export const sortPharmaciesByPrice = (pharmacies: Pharmacy[]) => {
  return pharmacies.sort((pharmacyA, pharmacyB) => {
    if (pharmacyB.drugPrice === undefined) {
      return -1;
    }

    if (pharmacyA.drugPrice === undefined) {
      return 1;
    }

    return pharmacyA.drugPrice < pharmacyB.drugPrice ? -1 : 1;
  });
};
